import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useColorTheme = () => {
  const [colors, setColors] = useState(null);

  useEffect(() => {
    fetchColors();
  }, []);

  const fetchColors = async () => {
    try {
      const response = await axios.get(`${API_URL}/color-theme`);
      setColors(response.data);
      applyColors(response.data);
    } catch (error) {
      console.error('Error fetching color theme:', error);
    }
  };

  const applyColors = (colorTheme) => {
    if (!colorTheme) return;

    const root = document.documentElement;
    
    // Apply colors directly to CSS variables
    root.style.setProperty('--theme-primary', colorTheme.primary);
    root.style.setProperty('--theme-secondary', colorTheme.secondary);
    root.style.setProperty('--theme-accent', colorTheme.accent);
    root.style.setProperty('--theme-background', colorTheme.background);
    root.style.setProperty('--theme-text', colorTheme.text);
    root.style.setProperty('--theme-button-primary', colorTheme.buttonPrimary);
    root.style.setProperty('--theme-button-text', colorTheme.buttonText);
  };

  return { colors, refreshColors: fetchColors };
};
